import { render, staticRenderFns } from "./AddDividend.vue?vue&type=template&id=25a1ab14"
import script from "./AddDividend.vue?vue&type=script&lang=js"
export * from "./AddDividend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports